import { init, setTags } from '@sentry/nextjs';
import Cookies from 'js-cookie';
import App from 'next/app';
import Head from 'next/head';
import Script from 'next/script';
import withRedux from 'next-redux-wrapper';
import { Provider } from 'react-redux';

import { AppContext } from '../context/';

import '../styles/bootstrap.css';
import '../styles/root.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';

import initStore from '../redux';
import { getProfile } from '../redux/actions/aeMyProfile';
import { setUser, validateUserByCookie } from '../redux/actions/auth';
import { setCurrentTimestampDelta } from '../redux/apis/generic';

import { Toast } from '../components/atoms';
import { OfflineObserver } from '../components/molecules';

import { headTitlesMap, AWIGN_DESCRIPTION, VIEWPORT_DESC } from '../constants';

// import {Header} from '../components/organisms/';
// const OnboardingScreens = dynamic(() => import('../components/templates/Onboarding/Screens'), {loading: () => 'Loading...'});
// import {handleMobileOnboarding} from '../utils/onboarding';

init({
  dsn: 'https://129f0068a1cc3ebea91d7c0e9bedea2b@o100966.ingest.sentry.io/4506375532052480',

  // integrations: [new Integrations.BrowserTracing()],

  tracesSampleRate: 1.0
});

export default withRedux(initStore, { debug: false })(
  class MyApp extends App {
    // this method get call on both server and client side

    static async getInitialProps({ Component, ctx }) {
      let isMobile;
      let pageProps = {};
      const onboardingInfo = {};

      try {
        // if server then set isMobile, setUser, setReferralCode, handleMobileOnboarding and handleWebOnboarding

        if (ctx.isServer) {
          const userAgent = ctx.req.headers['user-agent'];

          isMobile = /iPhone|iPad|iPod|Android/i.test(userAgent);
          await ctx.store.dispatch(setUser(ctx));

          // ctx.store.dispatch(setReferralCode(ctx));

          const state = ctx.store.getState();
          const currentUser = state.currentUser.data;

          if (currentUser) {
            await ctx.store.dispatch(getProfile(ctx));

            // if (ctx.req.url.includes('/partner')) {
            //   await ctx.store.dispatch(getPartnerProfile(ctx));
            // } else {
            //   await ctx.store.dispatch(getClientProfile(ctx));
            // }
            // const new_state = ctx.store.getState();

            if (ctx.req.url.includes('/partner')) {
              // handleMobileOnboarding(ctx, new_state);
            } else {
              // handleMobileOnboarding(ctx, new_state);
            }
          }
        } else {
          // for client side set isMobile only

          const userAgent = window.navigator.userAgent;

          isMobile = /iPhone|iPad|iPod|Android/i.test(userAgent);
        }

        if (Component.getInitialProps) {
          pageProps = await Component.getInitialProps(ctx);
        }

        return { pageProps, isMobile, onboardingInfo };
      } catch (error) {
        // if anything fails push error to sentry

        return {
          hasError: true,
          isMobile,
          pageProps
        };
      }
    }

    state = {
      isMobile: false
    };

    componentDidMount() {
      setCurrentTimestampDelta();
      this.handleResize();
      window.addEventListener('resize', this.handleResize);
      const profile_data = this.props.store?.getState()?.my_profile?.data;

      if (!this.props.isServer) {
        this.props.store.dispatch(validateUserByCookie());
      }

      if (process.env.CONFG_ENV === 'prod' && window.clarity) {
        const email = profile_data?.data?.email;
        const name = profile_data?.data?.full_name;
        const sid = Cookies.get('sid');

        if (name ? true : false) {
          window.clarity('set', 'userName', name);
          setTags({ name });
        }

        if (email ? true : false) {
          window.clarity('set', 'userEmail', email);
          window.clarity('identify', email);
          setTags({ email });
        }

        window.clarity('set', 'userSessionId', sid);
        setTags({ sid });
      }
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
    }

    handleResize = () => {
      if (window.innerWidth < 768) {
        if (this.state.isMobile) return;

        this.setState({ isMobile: true });
      } else {
        if (!this.state.isMobile) return;

        this.setState({ isMobile: false });
      }
    };

    render() {
      const { Component, pageProps, store, isMobile, router } = this.props;
      const pageTitle = headTitlesMap[router.pathname] || `Awign Expert: Your Source for the Best High-Skill Gig and Contractual Job Opportunities`;

      // const isLanguageSet = typeof window !== 'undefined' && localStorage.getItem('language');

      return (
        <>
          <Head>
            <title>{pageTitle}</title>
            <meta content={AWIGN_DESCRIPTION} name='description' />
            <meta content={VIEWPORT_DESC} name='viewport' />
          </Head>
          <Provider store={store}>
            <AppContext.Provider value={{ isMobile: isMobile || this.state.isMobile }}>
              <Component {...pageProps} isMobile={isMobile} />
              <OfflineObserver />
              <Toast />
            </AppContext.Provider>
          </Provider>
          {process.env.CONFG_ENV === 'prod' ? <Script id='new-relic-logging' src='/scripts/new-relic.js' strategy='afterInteractive' /> : null}
        </>
      );
    }
  }
);
